<template>
  <div class="body_center_right_recruit">
    <img src="@/components/Right/imgs/right_recruit_img.jpg" />
  </div>
</template>

<script>
import "@/assets/css/right.css"
export default {
  components: {
  },
  data () {
    return{
      
    }
  },
  created () {
  },
  methods: {
    
  }
}
</script>
<style scoped>
</style>